<phito-app
    [logo]="'assets/logo-phito-dark.png'"
    [logoWidth]="'90px'"
    [logoklein]="'assets/logo-klein.png'"
    [options]="options"
    [mainMenuConfig]="mainMenuConfig"
>
    @if (sessionService.loggedIn()) {
        @if (!hideSchuleSelector) {
            @if (schuleService.schule()) {
                <h2 style="cursor: pointer;" (click)="openSchuleDialog()">{{schuleService.schule()?.name}}</h2>
                <button mat-icon-button (click)="schuleService.schule.set(null)"><mat-icon>close</mat-icon></button>
            } @else {
                <h2 style="cursor: pointer;" (click)="openSchuleDialog()">Schule auswählen</h2>
            }
        }
    }
</phito-app>
